<template>
  <button class="close-button" type="button" @click="handleClick">
    <icon icon="close" width="40" height="40" />
  </button>
</template>

<script>
export default {
  name: "close-button",
  methods: {
    handleClick() {
      this.$emit("handle-click")
    },
  },
}
</script>

<style lang="scss" scoped>
.close-button {
  background: rgba(0, 26, 38, 0.1);
  border: 1px solid transparent;
  border-radius: 100%;
  color: var(--text-color);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  transition: all 0.25s linear;
  &:hover,
  :focus,
  :focus-within {
    border-color: var(--red);
    color: var(--red);
  }
  &:focus,
  :focus-within {
    outline: none;
  }
}
</style>
